enum projectStatus {
    processing = 1, // กำลังดำเนินการ
    completed = 2, // ดำเนินการเสร็จสมบูรณ์
    closed = 3, // ปิดโครงการ
    rejected = 4, // ไม่อนุมัติ
    notScope = 5, // ไม่เข้าข่าย
    terminate = 6, // ยุติโครงการ
    withdraw = 7, //ถอนโครงการ
}
export default projectStatus
